var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoaded)?_c('div',[(_vm.showHeader)?_c('page-header',{attrs:{"right-actions":[],"show-logo":"","bottom-border":"","logo-color":_vm.logoColor}}):_vm._e(),_vm._v(" "),_c('content-loader')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }